import React, {useEffect, useState} from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import '@fortawesome/fontawesome-free/css/all.min.css';
import bLogo from './img/logo_big.webp';
import pSchool from './img/school_1.jpeg';
import ApiService from './api/ApiService';
import {Box, Container, ImageList, ImageListItem, Link, Typography} from "@mui/material";


function About() {
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    const [staff, setStaff] = useState([]);

    useEffect(() => {
        ApiService.axiosInstance.get('/api/public/staff')
            .then(response => {
                setStaff(response.data);
            })
            .catch(error => {
                console.log(error);
            });
    }, []);


    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 768);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);


    return (
        <Container>
            <Box mt={4} mb={2}>
                <Typography align={'center'} variant={'h5'} gutterBottom sx={{textTransform: 'uppercase' }} fontWeight={'bold'}>
                    о школе
                </Typography>
                <ImageList cols={isMobile ? 1 : 2}>
                    <ImageListItem >
                        <Typography variant={'h6'} gutterBottom>
                            Наша уникальность - это, в первую очередь, люди, которые принимают участие в создании проекта, а также
                            работают в школе.
                            Наш учредитель и основатель проекта, Наталья Александровна Иванова, из династии профессиональных
                            педагогов, история которой насчитывает более 100 лет, многодетная мама.
                            Все сотрудники нашей школы проходят собеседования в несколько этапов, где решающим фактором являются
                            человеческие качества и любовь к детям.
                            Будем очень рады сотрудничеству с идейными педагогами, которые любят свою профессию и которым близки
                            наши ценности!
                            <br/>Напишите нам о себе на
                            <Link href="mailto:oktsmolensk@gmail.com"> oktsmolensk@gmail.com</Link>
                        </Typography>
                    </ImageListItem>
                    <ImageListItem sx={{
                        display: 'flex',
                        justifyContent: 'center', // по горизонтали
                        alignItems: 'center',     // по вертикали
                        width: '100%',
                    }}>
                        <Box
                            sx={{
                                position: 'relative',
                                width: '100%',
                                maxWidth: 640,
                                aspectRatio: '16 / 9',
                                borderRadius: 2,
                                overflow: 'hidden',
                                boxShadow: 2,
                            }}
                        >
                            <iframe
                                src="https://www.youtube.com/embed/QSbKVXWWLvo"
                                title="Частная школа — проект многодетной мамы из династии педагогов."
                                style={{
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                    width: '100%',
                                    height: '100%',
                                    border: 0,
                                }}
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                referrerPolicy="strict-origin-when-cross-origin"
                                allowFullScreen
                            ></iframe>
                        </Box>
                    </ImageListItem>
                </ImageList>
            </Box>
            <Box mt={4} mb={2}>
                <Typography align={'center'} variant={'h5'} gutterBottom sx={{textTransform: 'uppercase' }} fontWeight={'bold'}>
                    миссия
                </Typography>
                <Typography variant={'h6'} gutterBottom>
                    Создавая гармоничную среду для развития и обучения детей, мы делаем инвестиции в счастливое общество!
                    Также мы всем сердцем хотим продолжить великий вклад княгини М. К. Тенишевой в развитие образования нашей
                    страны.
                </Typography>
            </Box>
            <Box mt={4} mb={2}>
                <Typography align={'center'} variant={'h5'} gutterBottom sx={{textTransform: 'uppercase' }} fontWeight={'bold'}>
                    Почему на ЛОГО птица?
                </Typography>
                <ImageList cols={isMobile ? 1 : 2}>
                    <ImageListItem
                        sx={{
                            display: 'flex',
                            justifyContent: 'center', // по горизонтали
                            alignItems: 'center',     // по вертикали
                        }}>

                        <img src={bLogo} alt={'logo'} loading={"lazy"}
                             style={{ width: '30%', height: 'auto', objectFit: 'contain', alignContent:'center' }}
                        />
                    </ImageListItem>
                    <ImageListItem >
                        <Typography variant={'h6'} gutterBottom>
                            Символика птицы очень созвучна нашим ценностям - свободы, мира и знаний.
                            Стиль оригами был выбран как воплощение акта творения, когда из материи рождается форма.
                            Цветовая гамма яркая, так как детство и юношество - самое яркое время в жизни человека.
                            И наша задача пронести эти краски во взрослую жизнь.
                            И, конечно, символика птицы отражена в гербе нашего города и дорога всем смолянам.<br/>
                        </Typography>
                    </ImageListItem>
                </ImageList>
            </Box>
            <Box mt={4} mb={2}>
                <Typography align={'center'} variant={'h5'} gutterBottom sx={{textTransform: 'uppercase' }} fontWeight={'bold'}>
                    здание школы
                </Typography>
                <ImageList cols={isMobile ? 1 : 2}>
                    <ImageListItem >
                        <Typography variant={'h6'} gutterBottom>
                            Изначально оно строилось под образовательный проект (бывший Техникум при Льнокомбинате),
                            а вот новый фасад разрабатывался уже для нашей школы.
                            Во внутреннем дизайне интерьера мы осознанно не использовали «детскую тематику».
                            Задачей было создание универсального стильного пространства,
                            где много света и нет лишнего визуального «шума».
                        </Typography>
                    </ImageListItem>
                    <ImageListItem sx={{
                        display: 'flex',
                        justifyContent: 'center', // по горизонтали
                        alignItems: 'center',     // по вертикали
                    }}>
                        <img src={pSchool} alt={'logo'} loading={"lazy"}
                             style={{ width: '60%', height: 'auto', objectFit: 'contain', alignContent:'center' }}
                        />
                    </ImageListItem>
                </ImageList>
            </Box>
            <Box mt={4} mb={2}>
                <Typography align={'center'} variant={'h5'} gutterBottom sx={{textTransform: 'uppercase' }} fontWeight={'bold'}>
                    команда
                </Typography>

                <ImageList cols={isMobile ? 2 : 5} gap={16}>
                    {staff.map((person, index) => (
                        <ImageListItem key={index} sx={{ textAlign: 'center' }}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    mb: 1,
                                }}
                            >
                                <img
                                    src={ApiService.getMediaURL(person.foto)}
                                    alt={person.name}
                                    loading="lazy"
                                    style={{
                                        width: '100%',
                                        height: 'auto',
                                        borderRadius: '12px',
                                        objectFit: 'cover',
                                    }}
                                />
                            </Box>

                            <Typography variant="subtitle1" fontWeight="bold">
                                {person.name}
                            </Typography>
                            {person.job && (
                                <Typography variant="body2" color="text.secondary">
                                    {person.job}
                                </Typography>
                            )}
                        </ImageListItem>
                    ))}
                </ImageList>
            </Box>
        </Container>
    );
}

export default About;